import React from 'react';
import ModalInc from '../../../../../shared-ui/ModalInc';
import ButtonInc from '../../../../../shared-ui/ButtonInc';
import Grid from '@material-ui/core/Grid';
import { CircularProgress } from '@mui/material';
import TableInc from '../../../../../shared-ui/TableInc';
import { getPartner } from '../../../../../lib/access.es6';

// Shown from the moment documentation is finalised: opens in a progress state
// while the benefit-usage invoices are being auto-created, updating live, then
// settles into a summary of what was created (and what could not be, e.g. a
// benefit already used up on another claim).
const AutoInvoiceSummary = (props) => {
  if (!props.open) {
    return null;
  }

  const currencyCode = getPartner().country.currency_code;
  const created = props.created || [];
  const failures = props.failures || [];
  const creating = !!props.creating;
  const total = props.total || created.length + failures.length;
  const done = created.length + failures.length;

  const rows = created.map((line) => {
    const expenseCode =
      line.additional_details && line.additional_details.expense_code
        ? line.additional_details.expense_code
        : 'N/A';
    return {
      benefit_type: line.benefit_type,
      expense_code: expenseCode,
      amount:
        currencyCode +
        ' ' +
        ((line.benefit_amount_in_cents || 0) / 100).toLocaleString(),
    };
  });

  return (
    <ModalInc
      modalTitle={creating ? 'Creating Invoices…' : 'Invoices Auto-Created'}
      subTitle={
        props.invoiceNumber
          ? 'Invoice number ' + props.invoiceNumber
          : 'Benefit-usage invoices generated from the claim benefits'
      }
      open={props.open}
      onClose={creating ? function () {} : props.onClose}
      fullWidth
    >
      <Grid container spacing={2}>
        {creating && (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{ display: 'flex', alignItems: 'center', gap: 12 }}
          >
            <CircularProgress size={22} />
            <span>
              Creating benefit-usage invoices… ({done} of {total})
            </span>
          </Grid>
        )}

        <Grid item xs={12} sm={12} md={12}>
          {rows.length > 0 ? (
            <TableInc
              columns={[
                { title: 'Benefit', field: 'benefit_type' },
                { title: 'Expense Code', field: 'expense_code' },
                { title: 'Amount', field: 'amount' },
              ]}
              data={rows}
              options={{
                pageSize: rows.length < 5 ? rows.length || 1 : 5,
                showTitle: false,
                search: false,
                paging: false,
                toolbar: false,
              }}
            />
          ) : (
            !creating && <p>No invoices could be created for this claim.</p>
          )}
        </Grid>

        {failures.length > 0 && (
          <Grid item xs={12} sm={12} md={12}>
            <p style={{ color: '#8F191C', fontWeight: 600, marginBottom: 4 }}>
              Not created ({failures.length}) — please review manually:
            </p>
            <ul style={{ marginTop: 0 }}>
              {failures.map((failure, index) => (
                <li key={index} style={{ color: '#8F191C' }}>
                  {failure.benefit_type}
                  {failure.message ? ' — ' + failure.message : ''}
                </li>
              ))}
            </ul>
          </Grid>
        )}

        <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
          <ButtonInc
            variant="contained"
            color="primary"
            size="large"
            disabled={creating}
            onClick={props.onClose}
          >
            {creating ? 'Please wait…' : 'Ok'}
          </ButtonInc>
        </Grid>
      </Grid>
    </ModalInc>
  );
};

export default AutoInvoiceSummary;
